import type { FC } from "react";
import { PiCaretDownBold } from "react-icons/pi";
import Icon from "../../../icon/icon";
import ToolbarDropdown from "../../../toolbar-dropdown/toolbar-dropdown";
import type { ToolbarOptionConfig } from "../../../toolbar-dropdown/toolbar-dropdown.types";
import * as CSS from "./toolbat-stat.styles";

type ToolbarStatProps = {
	id: string;
	value: string;
	label: string;
	options?: ToolbarOptionConfig[];
	isMenuOpen?: boolean;
	onMenuOpen?: (id: string) => void;
	onMenuItemSelected?: (id: string) => void;
};

const ToolbarStat: FC<ToolbarStatProps> = ({
	id,
	label,
	value,
	options,
	isMenuOpen,
	onMenuOpen,
	onMenuItemSelected,
}) => {
	const shouldShowDropdown = options && options.length > 0;

	return (
		<CSS.ToolbarStat>
			<CSS.DisplayContainer>
				<div style={{ display: "flex", gap: "0.2rem" }}>
					<CSS.Value>{value}</CSS.Value>
					{shouldShowDropdown && (
						<Icon
							icon={PiCaretDownBold}
							size={20}
							as="button"
							onClick={() => onMenuOpen?.(id)}
						/>
					)}
				</div>
				<CSS.Label>{label}</CSS.Label>
			</CSS.DisplayContainer>
			{isMenuOpen && shouldShowDropdown && (
				<ToolbarDropdown
					items={options}
					onMenuItemSelected={onMenuItemSelected}
				/>
			)}
		</CSS.ToolbarStat>
	);
};

export default ToolbarStat;
